module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('PageTitle', {
    attrs: {
      "results-filters": _vm.resultsFilters
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "well collisions-filters"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "well-content"
  }, [_c('FilterDate', {
    attrs: {
      "default-option": {
        key: '2023',
        label: '2023'
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "filter-map"
  }, [_c('span', {
    staticClass: "filter-map-label"
  }, [_vm._v("Limit results to map area?")]), _vm._v(" "), _c('FilterMapActive')], 1), _vm._v(" "), _c('FilterSubmitButton', {
    class: [{
      'is-loading': _vm.isLoading
    }],
    attrs: {
      "routeName": 'collisions',
      "routeParams": _vm.routeParams
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-grid l-grid-small"
  }, [_c('Who'), _vm._v(" "), _c('DamageCosts', {
    attrs: {
      "getter": 'collisionsView/damageCosts/get',
      "title": 'Economic costs',
      "bar-color": this.$store.getters.green.light.a,
      "chart-height": 300
    }
  }), _vm._v(" "), _c('Weather', {
    attrs: {
      "card-color": 'blue',
      "card-icon": 'cloud',
      "getter": 'collisionsView/weather/get',
      "table-color": 'blue',
      "title": 'Weather',
      "bar-color": this.$store.getters.blue.light.a,
      "chart-height": 380,
      "x-min-axes-rotation": 75
    }
  }), _vm._v(" "), _c('RoadConditions', {
    attrs: {
      "card-color": 'orange',
      "getter": 'collisionsView/roadConditions/get',
      "table-color": 'orange',
      "title": 'Road conditions',
      "bar-color": this.$store.getters.orange.light.a,
      "chart-height": 380
    }
  }), _vm._v(" "), _c('LightConditions', {
    attrs: {
      "card-color": 'yellow',
      "card-icon": 'wb_incandescent',
      "getter": 'collisionsView/lightConditions/get',
      "table-color": 'yellow',
      "title": 'Light conditions',
      "bar-color": this.$store.getters.yellow.light.a,
      "chart-height": 310
    }
  }), _vm._v(" "), _c('CollisionTypes', {
    attrs: {
      "card-color": 'purple',
      "card-icon": 'call_split',
      "getter": 'collisionsView/collisionTypes/get',
      "table-color": 'purple',
      "title": 'Collision types',
      "bar-color": this.$store.getters.purple.light.a,
      "chart-height": 310
    }
  }), _vm._v(" "), _c('JunctionTypes', {
    attrs: {
      "card-color": 'teal',
      "getter": 'collisionsView/junctionTypes/get',
      "table-color": 'teal',
      "title": 'Junction types',
      "bar-color": this.$store.getters.teal.light.b,
      "chart-height": 520,
      "x-min-axes-rotation": 80
    }
  }), _vm._v(" "), _c('AddressTypes', {
    attrs: {
      "card-color": 'teal',
      "getter": 'collisionsView/addressTypes/get',
      "table-color": 'teal',
      "title": 'Address types',
      "bar-color": this.$store.getters.teal.light.b
    }
  })], 1), _vm._v(" "), _c('CollisionMap', {
    attrs: {
      "map-active": _vm.mapActive
    }
  }), _vm._v(" "), _c('Collision')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card red"
  }, [_c('h2', {
    staticClass: "card-h2",
    staticStyle: {
      "padding": "1em"
    }
  }, [_vm._v("NOTE: Data is available from 2006 to June 1, 2023.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "well-title collisions-filters-title"
  }, [_c('span', [_vm._v("Filter collisions")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55469f7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Collisions.vue
// module id = 469
// module chunks = 1